import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { type UUID } from '~/types/common';

import { queryKeysCompany } from '../queryKeys';

import { fetchCompanyInvoiceSendingSettings } from './fetchCompanyInvoiceSendingSettings';

/**
 * React Query based custom hook for getting invoice sending settings for a single company.
 *
 * @param companyId - Company ID to fetch settings for.
 * @param options - Additional options for the useQuery hook.
 * @returns Query result for the company invoice sending settings.
 */
export const useQueryCompanyInvoiceSendingSettings = (
  companyId: UUID,
  options?: Record<string, unknown>,
) =>
  useQuery({
    enabled: Boolean(companyId),
    queryFn: async () => fetchCompanyInvoiceSendingSettings(companyId),
    queryKey: queryKeysCompany.getInvoiceSendingSettings(companyId),
    staleTime: ms('5m'),
    // Errors are returned for the caller to render, not thrown to an error boundary.
    throwOnError: false,
    ...options,
  });
